import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

const OverlayLoader = ({ open, text = "Loading..." }) => (
  <Backdrop
    sx={{
      color: '#fff',
      zIndex: (theme) => theme.zIndex.drawer + 1,
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    }}
    open={open}
  >
    <CircularProgress color="inherit" />
    <Typography variant="h6">{text}</Typography>
  </Backdrop>
);

export default OverlayLoader;
